// extracted by mini-css-extract-plugin
export var chip = "_d9-0";
export var filterDropdown = "_d9-5";
export var filterItem = "_d9-6";
export var icon = "_d9-1";
export var removeButton = "_d9-3";
export var removeIcon = "_d9-4";
export var separator = "_d9-2";